module.exports = __webpack_public_path__ + "0e1ccca7ba3a51d376007bdf0e1b7b34.svg";